import React from "react";
import { Box, styled } from "@material-ui/core";

import { DemandActivity } from "../../../api/services";
import { NoteIcon } from "../../../icons";
import { ActivityListItem } from "./ActivityListItem";
import { useTruncate } from "../../../hooks";
import { ActivityTitle } from "./ActivityTitle";
import { useDemandActivity } from "../hooks/useDemandActivity";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const SummaryBox = styled(Box)(() => ({
  overflowWrap: "break-word",
}));

export const DemandActivityItem: React.FC<{
  activity: DemandActivity;
}> = ({ activity }) => {
  const { title, link } = useDemandActivity(activity);

  return (
    <ActivityListItem
      icon={<NoteIcon width={16} height={16} />}
      title={
        <ActivityTitle>
          {title}
          <SummaryBox>{useTruncate(activity.content, 120)}</SummaryBox>
        </ActivityTitle>
      }
      activityDttm={activity.activityDttm}
      linkTo={link}
    />
  );
};

export const DemandActivitySummaryCell: React.FC<{
  activity: DemandActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { title } = useDemandActivity(activity);
  return (
    <ActivitySummaryCell
      isGrey={isGrey}
      icon={<NoteIcon width={16} height={16} />}
      summary={`${title}: ${useTruncate(activity.content, 120)}`}
    />
  );
};
